<script setup>
const props = defineProps({ tone: { type: String, default: 'neutral' } })
const tones = {
  neutral: 'bg-slate-100 text-slate-700',
  brand: 'bg-brand-50 text-brand-700',
  success: 'bg-success-50 text-success-700',
  warning: 'bg-warning-50 text-warning-700',
  danger: 'bg-danger-50 text-danger-700',
  info: 'bg-info-50 text-info-700'
}
</script>
<template><span class="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-black" :class="tones[props.tone] || tones.neutral"><slot /></span></template>
